import defaultFetch from 'isomorphic-unfetch';

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string;
  };
  fetch: typeof defaultFetch;
}

interface UserInfo {
  isUserLoggedIn: boolean;
  capitalLetter?: string;
  isSunwebCE?: boolean;
}

export const createUserApiClient = (dependencies: Partial<Dependencies> = {}) => {
  const {
    env = {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    },
    fetch = defaultFetch,
  } = dependencies as Dependencies;

  async function getUserInfo(): Promise<UserInfo> {
    const url = `${env.NEXT_PUBLIC_API_BASE_URL}/CustomerApi/IsCustomerLoggedIn`;

    const response = await fetch(url, {
      referrerPolicy: 'no-referrer-when-downgrade',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      return {
        isUserLoggedIn: false,
      };
    }

    const { isLoggedIn, name, isSunwebCE } = await response.json();

    if (!isLoggedIn) {
      return {
        isUserLoggedIn: false,
      };
    }

    return {
      isUserLoggedIn: response.ok,
      capitalLetter: name?.[0].toUpperCase() ?? '',
      isSunwebCE: isSunwebCE ?? false,
    };
  }

  async function logout(): Promise<void> {
    const url = `${env.NEXT_PUBLIC_API_BASE_URL}/Auth/Logout`;

    await fetch(url, {
      referrerPolicy: 'no-referrer-when-downgrade',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
      method: 'POST',
    });
  }

  return {
    getUserInfo,
    logout,
  };
};
